import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  PostTriggersResponseTO,
  TriggersUpdatePayload,
} from 'models/automation/Triggers';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    PostTriggersResponseTO,
    BaseErrorResponse,
    TriggersUpdatePayload
  >,
  'mutationFn' | 'mutationKey'
>;

const updateTrigger = (payload: TriggersUpdatePayload) => {
  return API.put<PostTriggersResponseTO, BaseErrorResponse>(
    '/api/internal/triggers',
    payload,
  );
};

const useUpdateTriggerMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: updateTrigger,
    ...options,
  });
};

export default useUpdateTriggerMutation;
